import apiClient from "@/app/api/client";
import { soatoEndpoints } from "@/app/api/endpoints";
import type { ListSoatosParams, Soato, SuccessResponse } from "../types";

export const soatoService = {
	async list(params?: ListSoatosParams): Promise<Soato[]> {
		const response = await apiClient.get<SuccessResponse<Soato[]>>(soatoEndpoints.list, { params });
		return response.data.data;
	},
};
